import types from '../types';

const getStats = () => {
  return {
    type: types.REQUEST_GET_STATS,
  };
};

const getStatsByTime = (data) => {
  return {
    ...data,
    type: types.REQUEST_STATS_BY_TIME,
  };
};

const getMessageStats = (data) => {
  return {
    ...data,
    type: types.REQUEST_MESSAGE_STATS,
  };
};

const getHighlightHist = (data) => {
  return {
    ...data,
    type: types.REQUEST_GET_HIGHLIGHT_HIST,
  };
};

const getCampaignStats = (data) => {
  return {
    ...data,
    type: types.REQUEST_GET_CAMPAIGN_STATS,
  };
};

export default {
  getCampaignStats,
  getHighlightHist,
  getStatsByTime,
  getStats,
  getMessageStats,
};
